import { useState, useEffect } from "react";
import { Search, AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

const alertLabels = { late: "Atraso", early_leave: "Saída Antecipada", overtime: "Hora Extra", outside_geofence: "Fora da Área" };
const alertStyles = { late: { bg: "rgba(249,115,22,0.1)", color: "#f97316", border: "rgba(249,115,22,0.2)" }, early_leave: { bg: "rgba(249,115,22,0.1)", color: "#f97316", border: "rgba(249,115,22,0.2)" }, overtime: { bg: "rgba(59,130,246,0.1)", color: "#3b82f6", border: "rgba(59,130,246,0.2)" }, outside_geofence: { bg: "rgba(239,68,68,0.1)", color: "#ef4444", border: "rgba(239,68,68,0.2)" } };

export default function AlertsPage() {
  const { user } = useAuth();
  const [alerts, setAlerts] = useState([]);
  const [operators, setOperators] = useState([]);
  const [opFilter, setOpFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/operators").then((r) => setOperators(r.data)).catch(() => {}); }, []);

  const fetch = async () => {
    setLoading(true);
    const params = {};
    if (opFilter) params.operator_id = opFilter;
    if (typeFilter) params.alert_type = typeFilter;
    api.get("/workforce/alerts", { params }).then((r) => setAlerts(r.data)).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { fetch(); }, [opFilter, typeFilter]);

  return (
    <div data-testid="alerts-page">
      <h1 className="crm-heading mb-8 flex items-center gap-2"><AlertTriangle className="w-6 h-6" style={{ color: "#ef4444" }} /> Alertas</h1>

      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <select value={opFilter} onChange={(e) => setOpFilter(e.target.value)} className="crm-input" style={{ maxWidth: "250px" }}>
          <option value="">Todos operadores</option>
          {operators.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
        </select>
        <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)} className="crm-input" style={{ maxWidth: "200px" }}>
          <option value="">Todos tipos</option>
          <option value="late">Atraso</option>
          <option value="early_leave">Saída Antecipada</option>
          <option value="overtime">Hora Extra</option>
          <option value="outside_geofence">Fora da Área</option>
        </select>
      </div>

      <div className="crm-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="crm-table">
            <thead><tr><th>Data</th><th>Operador</th><th>Entrada</th><th>Saída</th><th>Horas</th><th>Alertas</th></tr></thead>
            <tbody>
              {loading ? (
                [...Array(3)].map((_, i) => <tr key={i}><td colSpan={6}><div className="h-5 rounded animate-pulse" style={{ background: "var(--crm-border)" }} /></td></tr>)
              ) : alerts.length === 0 ? (
                <tr><td colSpan={6} className="text-center py-14" style={{ color: "var(--crm-text-dim)" }}>Nenhum alerta encontrado</td></tr>
              ) : alerts.map((e) => (
                <tr key={e.id}>
                  <td style={{ fontWeight: 500 }}>{e.date}</td>
                  <td className="primary">{e.operator_name}</td>
                  <td>{e.clock_in || "—"}</td>
                  <td>{e.clock_out || "—"}</td>
                  <td style={{ fontWeight: 600 }}>{e.total_hours ? `${e.total_hours}h` : "—"}</td>
                  <td>
                    <div className="flex flex-wrap gap-1.5">
                      {e.alerts?.map((a) => {
                        const s = alertStyles[a] || alertStyles.late;
                        return <span key={a} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-[11px] font-bold" style={{ background: s.bg, color: s.color, border: `1px solid ${s.border}` }}>{alertLabels[a] || a}</span>;
                      })}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <p className="text-xs mt-3" style={{ color: "var(--crm-text-dim)" }}>{alerts.length} registro(s) com alertas</p>
    </div>
  );
}
